var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.value)+" "),_c('label',{staticClass:"switch"},[_c('input',_vm._b({attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit("input", $event.target.checked)}}},'input',_vm.$attrs,false)),_c('span',{staticClass:"switch-indicator",attrs:{"for":_vm.id}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }